exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MainNav {\n  background: #333;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%;\n  /*\n\t * Elements\n\t */ }\n  .MainNav-link {\n    color: #e8e8e8;\n    display: block;\n    padding: 8px; }\n    .MainNav-link:hover {\n      background: #888;\n      color: #eee;\n      text-decoration: none; }\n    .MainNav-link.current {\n      background: #555;\n      color: #eee; }\n    .MainNav-link[href=\"/logout\"] {\n      background: #555;\n      padding: 16px;\n      margin-top: auto; }\n      .MainNav-link[href=\"/logout\"]:hover {\n        background: #888; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/MainNav/MainNav.scss
// module id = 1598
// module chunks = 0